import React, { useState, useEffect } from "react";
import { safeStr } from "common/api";
import { PERIOD_TO_HOURS } from "common/constants";
import Request from "common/Request";
import { parseServiceLatencies } from "../DPI/Latency/api";
import DPILatencies from "../DPI/Latency/Result/index";

const latencyRetrieval = ({ hours, categories, subscriberGroup }) => {
  return ifCl
    .run(
      `show statistics dpi latency top hours ${hours} categories ${
        categories - 1
      } all-subs all-internet subscriber-groups name ${safeStr(subscriberGroup)}`, { timeout: DPI_STATS_TMOUT_MS }
    )
    .then(parseServiceLatencies)
    .then((latencies) => {
      return {
        latencies,
      }
    });
};

const SubscriberGroupLatency = ({
  range,
  categories,
  direction,
  period,
  subscriberGroup,
}) => {
  const [request, setRequest] = useState(null);
  const hours = PERIOD_TO_HOURS[period];
  const context = { interval:10, hours, directions:direction, categories, subscriberGroup };

  const doLoad = () => {
    setRequest(latencyRetrieval({ hours, categories, subscriberGroup }));
  };

  useEffect(
    () => doLoad(),
    [ categories, hours, subscriberGroup]
  );
  return (
    <div>
      <Request during={request}>
        {({latencies}) => {
          return <DPILatencies latencies={latencies} range={range} {...context} className="subscriber-dashboard"/>;
        }}
      </Request>
    </div>
  );
};

export default SubscriberGroupLatency;
